module.exports = __webpack_public_path__ + "static/img/img-8.d4b940b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-8.png
// module id = iFih
// module chunks = 0